import React, { useState, useContext } from "react";
import {
  Grid,
  TextField,
  Button,
  Chip,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";

import { useField } from "react-final-form";
import useForm from "../../../../utils/useForm";
import SetupContext, { validateYard } from "./context";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  selectedAccess: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  addButton: {
    marginTop: theme.spacing(1.25),
    marginLeft: theme.spacing(1),
  },
  addInput: {
    marginTop: theme.spacing(1),

    minWidth: "50%",
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export default function AccessAndCapacity() {
  const { state, dispatch } = useContext(SetupContext);
  const { yardInfo } = state;
  const {
    input: { onChange },
  } = useField("setupData");
  const { handleChange } = useForm(state, dispatch, "yardInfo");
  const [newAcess, setNewAcess] = useState();
  const classes = useStyles();
  let { errors } = state;

  const handleRecordChange = (evt) => {
    debugger;
    onChange();
    handleChange(evt);
  };

  const addAccess = () => {
    debugger;
    if (!newAcess || yardInfo.accessToRailHighway?.includes(newAcess)) return;
    dispatch({ type: "ADD_ACCESS", payload: newAcess });
    setNewAcess("");
    onChange();
  };

  const handleSubmit = (evt) => {
    if (evt.key === "Enter") {
      addAccess("Add");
    }
  };

  const deleteAccess = (toDelete) => {
    dispatch({ type: "REMOVE_ACCESS", payload: toDelete });
    onChange();
  };

  const handleBlur = (evt) => {
    const errors = validateYard(state.yardInfo);
    dispatch({ type: "ERROR", payload: errors });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            name="lotCapacityAcres"
            label="Open Air Yard Capacity"
            id="outlined-margin-dense"
            helperText={
              errors["lotCapacityAcres"] ? errors["lotCapacityAcres"] : ""
            }
            error={errors["lotCapacityAcres"] ? true : false}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">Acres</InputAdornment>
              ),
            }}
            autoFocus
            required
            margin="dense"
            variant="outlined"
            fullWidth
            value={yardInfo.lotCapacityAcres}
            onChange={handleRecordChange}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="warehouseCapacity"
            label="Covered / Warehouse capacity"
            margin="dense"
            helperText={
              errors["warehouseCapacity"] ? errors["warehouseCapacity"] : ""
            }
            error={errors["warehouseCapacity"] ? true : false}
            variant="outlined"
            required
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">SqFt</InputAdornment>
              ),
            }}
            value={yardInfo.warehouseCapacity}
            onChange={handleRecordChange}
          ></TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="trackCapacity"
            label="Track capacity"
            margin="dense"
            helperText={errors["trackCapacity"] ? errors["trackCapacity"] : ""}
            error={errors["trackCapacity"] ? true : false}
            variant="outlined"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">Feet</InputAdornment>
              ),
            }}
            value={yardInfo.trackCapacity}
            onChange={handleRecordChange}
          ></TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="servingCarrier"
            label="Serving Rail Carrier"
            margin="dense"
            helperText={
              errors["servingCarrier"] ? errors["servingCarrier"] : ""
            }
            error={errors["servingCarrier"] ? true : false}
            variant="outlined"
            fullWidth
            value={yardInfo.servingCarrier}
            onChange={handleRecordChange}
          ></TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container>
            <Grid item xs={9}>
              <TextField
                name="accessToRailHighway"
                label="Accessible Highway(s)"
                value={newAcess}
                size="small"
                fullWidth
                variant="outlined"
                className={classes.addInput}
                onKeyDown={handleSubmit}
                onChange={(evt) => setNewAcess(evt.target.value.toUpperCase())}
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                className={classes.addButton}
                size="medium"
                variant="outlined"
                onClick={addAccess}
                startIcon={<AddIcon />}
              >
                Add
              </Button>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.selectedAccess}>
                {yardInfo?.accessToRailHighway?.map((option) => (
                  <Chip
                    variant="outlined"
                    key={option}
                    label={option}
                    onClick={() => alert}
                    onDelete={() => deleteAccess(option)}
                  />
                ))}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
